var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBriefcase = function SvgBriefcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M1.167 5.083a1 1 0 0 1 1-1h9.666a1 1 0 0 1 1 1v6.167a1 1 0 0 1-1 1H2.167a1 1 0 0 1-1-1V5.083Z",
    stroke: "#9AA0AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.333 12.25V2.917c0-.645-.522-1.167-1.166-1.167H5.833c-.644 0-1.166.522-1.166 1.167v9.333",
    stroke: "#9AA0AB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgBriefcase as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M1.16675 5.08337C1.16675 4.53109 1.61446 4.08337 2.16675 4.08337H11.8334C12.3857 4.08337 12.8334 4.53109 12.8334 5.08337V11.25C12.8334 11.8023 12.3857 12.25 11.8334 12.25H2.16675C1.61446 12.25 1.16675 11.8023 1.16675 11.25V5.08337Z' stroke='%239AA0AB' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M9.33341 12.25V2.91667C9.33341 2.27233 8.81108 1.75 8.16675 1.75H5.83341C5.18908 1.75 4.66675 2.27233 4.66675 2.91667V12.25' stroke='%239AA0AB' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E";